<template>
<div>
    <template  v-if="this.from">
        <template  v-if="this.plan != 'Y'">
            <!-- 고객에서 왔고 에듀플랜맵 메인일때 -->
            <base-header :pageName="pageNm" :popup="true"></base-header>
        </template>
        <template  v-else>
            <!-- 고객에서 왔고 나만의 상품 선택일때 -->
            <base-header :pageName="pageNm" :prevBtnShow="true" :popup="true"></base-header>
        </template>
    </template>
    <template  v-else>
        <template  v-if="this.plan != 'Y'">
            <!-- 에듀플랜맵 메뉴로 왔고 에듀플랜맵 메인일때 -->
            <base-header :pageName="pageNm" :prevBtnShow="true" history="main"></base-header>
        </template>
        <template  v-else>
            <!-- 에듀플랜맵 메뉴로 왔고 나만의 상품 선택일때 -->
            <base-header :pageName="pageNm" :prevBtnShow="true"></base-header>
        </template>
    </template>
    <section id="wrap">
        <div class="edu-plan">
            <template  v-if="this.plan != 'Y'">
            <div class="cus-info">
                <button type="button" @click="popCust" v-if="!this.from">고객조회</button>
                <template v-if="edu.kwkkey">
                    <ul>
                        <li>
                            <em>고객명</em>
                            <strong>{{edu.custNm}}</strong>
                        </li>
                        <li v-if="this.childList.length > 0">
                            <em>자녀명</em>
                            <base-selectbox selectName="자녀선택"
                                :default="childList2[0].text"
                                :only="false"
                                v-on:selectSearch="childSelected"
                                :options="this.childList2"
                                :key="childSelKey"
                            ></base-selectbox>
                        </li>
                    </ul>
                </template>
            </div>
            <div class="plan-info">
                <base-selectbox selectName="나만의 플랜 선택"
                    :default="'나만의 플랜 선택'"
                    :only="false"
                    v-on:selectSearch="myPlan"
                    :options="this.myPlanSelectBox"
                    v-if="myPlanList.length > 0"
                    :openMessage="openMessage"
                ></base-selectbox>

                <span class="book">북시네마</span>
                <span class="promotion" @click="showPromotionOutlink">프로모션 보기</span>
            </div>
            </template>

            <div class="category" :class="[plan == 'Y' ? 'first' : null]">
                <swiper class="swiper" :options="slideMenu" ref="slide">
                    <swiper-slide v-for="(item, index) in cateList" :key="index">
                        <em @click="catChoose(item,index)" :class="[ index == catIdx ? 'current' : null]">
                            {{item.cdNm}}
                        </em>
                    </swiper-slide>
                </swiper>
            </div>
            <swiper class="swiper" :options="slideMenu" ref="prdSlide" @slideChange="slideChangeTransitionStart">
                <swiper-slide v-for="(category, index) in cateList" :key="index">
                    <div class="wrap">
                        <div class="title">
                            <strong>{{category.cdNm}}</strong>
                            <span v-for="(item, index) in cateCntList.filter((item) => item.catCd == cat.cdVl1 )"
                                :key = "index">
                                <template v-if="plan != 'Y'" >
                                    (보유&nbsp; <i>{{item.concCnt | nvl(0)}}</i> &nbsp;|&nbsp; 선택&nbsp; <i>{{item.planCnt | nvl(0)}}</i>)
                                </template>
                            </span>
                        </div>
                        <div class="edu-list">
                            <button
                            v-for="(item, index) in productList.filter((item) => item.catCd == cat.cdVl1 )"
                            :key="index"
                            :class="[{'checkBtn': item.selected},item.bcnmYn == 'Y' ? 'link': null, item.prmtAplyYn == 'Y' ? 'prolink': null, {'checkBtnSel': item.disabled && item.catCd === 'AA'}]"
                            @click="prodChoice(item,index)"
                            :disabled = "item.disabled && item.catCd !== 'AA'"
                            v-longpress:[item]="onLongpress"
                            type="button">{{item.prdtnm}}</button>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
            <!-- <div class="wrap" v-for="category in cateList.filter((category) => category.cdVl1 == cat.cdVl1 )" :key="category.cd">
                <div class="title">
                    <strong>{{category.cdNm}}</strong>
                    <span v-for="(item, index) in cateCntList.filter((item) => item.catCd == cat.cdVl1 )"
                        :key = "index">
                        <template v-if="plan != 'Y'" >
                            (보유&nbsp; <i>{{item.concCnt | nvl(0)}}</i> &nbsp;|&nbsp; 선택&nbsp; <i>{{item.planCnt | nvl(0)}}</i>)
                        </template>
                    </span>
                </div>
                <div class="edu-list">
                    <button
                    v-for="(item, index) in productList.filter((item) => item.catCd == cat.cdVl1 )"
                    :key="index"
                    :class="[{'checkBtn': item.selected},item.bcnmYn == 'Y' ? 'link': null, item.prmtAplyYn == 'Y' ? 'prolink': null, {'checkBtnSel': item.disabled && item.catCd === 'AA'}]"
                    @click="prodChoice(item,index)"
                    :disabled = "item.disabled && item.catCd !== 'AA'"
                    v-longpress:[item]="onLongpress"
                    type="button">{{item.prdtnm}}</button>
                </div>
            </div> -->
        </div>
    </section>

    <div class="fltMn">
        <template v-if="this.plan != 'Y'">
            <button type="button" @click="flotMenu" class="float slide" :class="{'open' : this.menuView}"></button>
            <button type="button" @click="showPdf" class="float view" :class="{'open' : this.menuView}"></button>
            <button type="button" @click="myplan" class="float myplan" :class="{'open' : this.menuView}"></button>
            <button type="button" @click="cart" class="cart" :class="[{'open' : this.menuView},{'in': this.prodCart.length > 0 }]">
                <em>{{this.prodCart.length > 10 ? '10+' : this.prodCart.length}}</em>
            </button>
            <!-- 2026.09.18 챗봇 버튼-->
            <button type="button" class="chatbot allow-click" @click="chatbot"></button>
        </template>
        <template v-else>
            <button type="button" class="planSave" @click="planReg"></button>
        </template>
    </div>
</div>
</template>

<script>
import Vue from "vue";
Vue.directive("longpress", {
    bind: function (el, binding, vNode) {
        // Make sure expression provided is a function
        if (typeof binding.value !== "function") {
        // Fetch name of component
        var compName = vNode.context.name;
        // pass warning to console
        let warn = `[longpress:] provided expression '${binding.expression}' is not a function, but has to be`;
        if (compName) {
            warn += `Found in component '${compName}' `;
        }

        console.warn(warn);
        }

        // Define variable
        let pressTimer = null;

        // Define funtion handlers
        // Create timeout ( run function after 1s )
        let start = (e) => {
        if (e.type === "click" && e.button !== 0) {
            return;
        }

        if (pressTimer === null) {
            pressTimer = setTimeout(() => {
            // Run function
            handler();
            }, 1000);       //1초 누르고있을때
        }
        };

        // Cancel Timeout
        let cancel = (e) => {
        console.log(e);
        // Check if timer has a value or not
        if (pressTimer !== null) {
            clearTimeout(pressTimer);
            pressTimer = null;
        }
        };
        // Run Function
        var handler = () => {
        binding.value(binding.arg);
        };

        // Add Event listeners
        el.addEventListener("mousedown", start);
        el.addEventListener("touchstart", start);
        // Cancel timeouts if this events happen
        el.addEventListener("click", cancel);
        el.addEventListener("mouseout", cancel);
        el.addEventListener("touchend", cancel);
        el.addEventListener("touchcancel", cancel);
        el.addEventListener("touchmove", cancel);   // 터치상태 움직일경우 이벤트 취소
    },
});
export default {
  name: "plan-product",
  components: {
  },
  data() {
      return{
        pageNm: this.$route.query.myPlan!= 'Y' ? '에듀플랜맵' : '상품 선택',
        slideMenu: {
          slidesPerView: 'auto'
        },
        targetId: null, //하위 ep사번
        promotionInfo: {
            sqno:0
        },
        edu:{           //고객,자녀 정보
            kwkkey: '',
            custNm: '',
            custDiv: '',
            chlnKwkey: '',
            kwcnam: '',
            chlnBdt: '',
        },
        childList:[],   //자녀 목록
        childList2:[],  //자녁 선택 리스트
        childIdx: 0, // 선택 자녀 인덱스
        catIdx : 0,
        cateList:[],
        productList:[],
        cat:{
            cdNm: '',
            cdVl1: '',
        },
        cateCntList:[],
        menuView: false,
        prodCart: [],
        plan: this.$route.query.myPlan,
        from: this.$route.query.from,
        myPlanList:[],
        myPlanSelectBox:[{text:'나만의 플랜 선택', value:''}],
        userId:'',
        baseUrl:'',
        childSelKey: 0,
        loginGbn : this.$store.getters.loginGbn //로그인구분
      };
  },
  computed:{
    openMessage: function(){
        var msg = '';
        if(this.prodCart.length > 0){
            for(var idx=0 ; idx < this.productList.length ; idx++){
                if(this.productList[idx].selected && !this.productList[idx].disabled){
                    msg = '선택했던 상품이 해제될 수 있습니다.';
                }
            }
        }
        return msg;
      },
  },
  watch: { // 팝업창에서 선택된 값 받는 부분.
    '$store.state.ui.child'(child) {
        if(child.name == 'cust-selected'){  // 고객검색 팝업에서 받은 값.
            this.edu = this.$store.state.ui.child.data;
            if(this.$store.state.ui.child.data.userId){
                this.targetId = this.$store.state.ui.child.data.userId
            }
            this.getChildList()
        }else if(child.name == 'after-save-plan'){
            this.getPlanProduct();  //계약/선택 상품 재조회
        }else if(child.name == 'eduplan_close_and_refresh' && !child.data.from ){
            //나만의 플랜에서 저장후 처리 로직
            this.$router.go(-1)
        }
    }
  },
  methods: {
    slideChangeTransitionStart() {
        var index = this.$refs.prdSlide.$swiper.activeIndex; //현재 index값 얻기
        this.$refs.slide.$swiper.slideTo(index, 0);
        this.catIdx = index;

        this.cat.cdNm = this.cateList[index].cdNm;
        this.cat.cdVl1 = this.cateList[index].cdVl1;
    },
    popCust(){ // 고객조회
        if(this.$store.getters.orgnzPstn == 'COG01'){
            //지국장일때
            this.$utils.nativeIf.outbound.newPage('/eduplanmap/orgList');
        }else{
            //EP/지구장일때
            this.$utils.nativeIf.outbound.newPage('/commonPopup/custSearch/');
        }

    },
    getChildList(){    //자녀 조회
        const that = this;
        const parameters = {
            kwkkey: this.edu.kwkkey,
            custDiv: this.edu.custDiv,
        };
        const MIN_CHILDREN_NUM = 1;
        this.$api.eduplan.child(parameters).then(function (data) {
            let childList = data;
            let optionIndex = 0;
            that.childList = [];
            that.childList2 = [];
            that.childList = that.childList.concat(childList);
            for (let i = 0; i < that.childList.length; i++) {
                // 전체 option 추가
                if (i === 0 && that.childList.length >= MIN_CHILDREN_NUM) {
                    that.childList2.push({text: '전체', value: optionIndex++});
                }

                let title = '';
                if (that.childList[i].kwcnam)
                    title = that.childList[i].kwcnam
                if (that.childList[i].chlnAge)
                    title += '(' + that.childList[i].chlnAge + ')'

                that.childList2.push({text: title, value: optionIndex++});
            }

            // 자녀가 MIN_CHILDREN_NUM명 이상인 경우 자녀 데이터에 전체 추가(전체 선택 시 모든 부모 키를 사용함으로써 자녀 모두 조회)
            if (that.childList.length >= MIN_CHILDREN_NUM) {
                that.childList.unshift({kwcnam: '', chlnBdt: '', chlnAge: '', chlnKwkey: that.edu.kwkkey});
            }

            that.childSelKey++;
            that.childSelected(0)
        })
        .catch(function(error) {
            alert(error.rtMsg);
        });
    },
    childSelected: function(index){ // 자녀선택
        this.childIdx = index;
        if(this.childList.length > index){
            this.edu.chlnKwkey = this.childList[index].chlnKwkey
            this.edu.kwcnam = this.childList[index].kwcnam
            this.edu.chlnBdt = this.childList[index].chlnBdt
        }
        this.getPlanProduct();
    },
    getPlanProduct: function() { // 고객별 계약/선택 상품 조회
        const that = this
        let param = JSON.parse(JSON.stringify(this.edu));
        param.targetId = this.targetId;

        this.$api.eduplan.customerPlan(param).then(function (data) {
            that.cateCntList = data.cateCntList // 카테고리별 선택/계약 상품 수
            for (const prdt of that.productList) {
                prdt.selected = false
                prdt.disabled = false
                for (const checkPrdt of data.productList) {
                    if (prdt.salecdSqno === checkPrdt.salecdSqno) {
                        if (checkPrdt.planType === "1") {
                            // 보유 상품
                            prdt.disabled = true;
                        } else {
                            // 나만의 플랜 선택 상품
                            prdt.selected = true;
                        }
                    }
                }

            }
            that.setCartPrdt();
        }).catch(function (error) {
            alert(error.rtMsg);
        });
    },
    myPlan: function(data){ // 나만의 플랜의 상품 조회
        // this.openMessage = '';   // 한번 선택 후에 알림창 다시 안보여줌.
        if(data){
            var that = this
            this.$api.eduplan.customerPlan({epmMySqno : data}).then(function(data){
                if(data.productList){
                    for(var idx=0 ; idx < that.productList.length ; idx++){
                        var prdt = that.productList[idx]
                        var checked = false;
                        for(var idx2=0 ; idx2 < data.productList.length ; idx2++ ){
                            var checkPrdt = data.productList[idx2]
                            if(prdt.salecdSqno == checkPrdt.salecdSqno){
                                checked = true;

                                if(!prdt.disabled && !prdt.selected){  // 미계약상품 && 선택안됏었을때
                                    that.prodChoice(prdt); //선택상태로 변경
                                    prdt.selected = true
                                }
                                break;
                            }
                        }
                        if(!checked && prdt.selected && !prdt.disabled){  // 선택 => 선택 해제 (계약은 넘어감.)
                            that.prodChoice(that.productList[idx]); //해제 상태로 변경
                        }
                    }
                }
            })
            .catch(function(error) {
                alert(error.rtMsg);
            });
        }else{
            // 초기화
            if(this.edu.custDiv){
                // 고객 선택 되어있을때
                this.getPlanProduct();  // 고객/자녀 플랜 재조회
            }else{
                for(var idx=0 ; idx < this.productList.length ; idx++){
                    if(this.productList[idx].selected){     //선택된 상품.
                        this.prodChoice(this.productList[idx]);    //선택 해제
                    }
                }
            }
        }
    },

    catChoose: function(item, _index){ // 카테고리 선택
        this.catIdx = _index;
        this.$refs.prdSlide.$swiper.slideTo(_index);
        this.cat.cdNm = item.cdNm;
        this.cat.cdVl1 = item.cdVl1;

        // var index = this.$refs.prdSlide.$swiper.activeIndex; //현재 index값 얻기
        // this.$refs.slide.$swiper.slideTo(index, 0);
        // this.catIdx = index;


        // this.cat.cdNm = item.cdNm
        // this.cat.cdVl1 = item.cdVl1
    },

    prodChoice: function(item){ // 상품 선택
        if (this.childList.length && !this.childList[this.childIdx].kwcnam) {
            alert('자녀를 선택해 주세요');
            return;
        }

        if(this.prodCart.length > 89 && !item.selected){
            alert("상품은 90개까지 선택 가능합니다.");
            return false;
        }

        for(var i=0 ; i<this.cateCntList.length ; i++){
            if(this.cateCntList[i].catCd == item.catCd){
                if(!this.cateCntList[i].planCnt)
                    this.cateCntList[i].planCnt = 0
                if(item.selected){
                    this.cateCntList[i].planCnt -= 1
                }else{
                    this.cateCntList[i].planCnt += 1
                }

                break;
            }
        }
        this.$set(item, 'selected', !item.selected);
        this.setCartPrdt();
    },
    setCartPrdt: function(){
        var newCart=[];
        for (var i = 0; i < this.productList.length; i++) {
            if(this.productList[i].selected){
                newCart.push(this.productList[i])
            }
        }
        this.prodCart = newCart
    },

    flotMenu: function(){ // 하단 메뉴 열림/닫힘
        this.menuView = !this.menuView;
    },
    showPdf: function(){    //한눈에 보기
        if(!this.edu.custDiv || this.edu.custDiv == ""){
            alert("고객을 선택해주세요.")
            return false;
        }
        var strParam = this.baseUrl+"?custDiv="+this.edu.custDiv;
        if(this.edu.kwkkey)     strParam += "&kwkkey="+this.edu.kwkkey;
        if(this.edu.custNm)     strParam += "&custNm="+encodeURIComponent(this.edu.custNm);
        if(this.edu.chlnKwkey)  strParam += "&chlnKwkey="+this.edu.chlnKwkey;
        if(this.edu.kwcnam)     strParam += "&kwcnam="+encodeURIComponent(this.edu.kwcnam);
        if(this.edu.chlnBdt)    strParam += "&chlnBdt="+this.edu.chlnBdt;
        if(this.targetId)       strParam += "&targetId="+ this.targetId;
        if(this.userId)         strParam += "&userId="+ this.userId;

        this.$utils.nativeIf.outbound.outlink(strParam);
    },
    myplan: function(){ // 나만의 플랜 이동
        if(this.from && this.targetId){
            this.$router.push({ name: "my-plan", query:{from:"cust"}}).catch(function() {}).then((() =>window.scrollTo(0,0) ));
        }else{
            this.$router.push({ name: "my-plan" }).catch(function() {}).then((() =>window.scrollTo(0,0) ));
        }
    },
    cart: function(){ // 장바구니 이동
        if (this.childList.length && !this.childList[this.childIdx].kwcnam) {
            alert('자녀를 선택해 주세요');
            return;
        }

        if(this.prodCart.length > 0){
            var prdtKeyList = [];       //필요한 정보만 가져간다.
            for(var k=0 ; k<this.prodCart.length ; k++){
                prdtKeyList.push({salecdSqno : this.prodCart[k].salecdSqno})
            }
            var data = {
                planCart:{
                    list:prdtKeyList,
                    userInfo:this.edu,
                    targetId:this.targetId
                }
            }
            var parent = this.$store.getters.parent;
            Object.assign(parent.data, data)

            this.$store.commit("SET_UI_PARENT", parent);
            this.$utils.nativeIf.outbound.newPage('/eduplanmap/cart');
        }else{
            alert('상품을 선택해주세요.')
        }
    },
    planReg: function(){ // 나만의 플랜 저장 이동
        if(this.prodCart.length < 1){
            alert('상품을 선택해 주세요.')
            return false;
        }

        var prdtKeyList = [];       //필요한 정보만 가져간다.
        for(var k=0 ; k<this.prodCart.length ; k++){
            prdtKeyList.push({salecdSqno : this.prodCart[k].salecdSqno})
        }

        var data = {
            planReg:{
                list:prdtKeyList
            }
        }
        var parent = this.$store.getters.parent;
        Object.assign(parent.data, data)

        this.$store.commit("SET_UI_PARENT", parent);    // 나만의 플랜 저장 화면으로 보내는 정보
        this.$utils.nativeIf.outbound.newPage('/eduplanmap/planReg');
    },

    getBase: function(){ // 기본정보 조회
        var that = this;
        var parameters = {
            targetId: this.targetId,
        };
        this.$api.eduplan.base(parameters).then(function(data) {
			var myPlanList = data.myPlanList;
            that.myPlanList = that.myPlanList.concat(myPlanList);
            var i;
            for(i = 0; i < that.myPlanList.length; i++) {   //나만의 플랜 목록
                that.myPlanSelectBox.push({text:that.myPlanList[i].planNm, value:that.myPlanList[i].epmMySqno})
            }

            if (data.productList) { //상품 전체 목록
                // 1) 전체 리스트는 그대로 합치기
                const merged = that.productList.concat(data.productList);

                // 2) HC만 뽑아서 salecdSqno ASC 정렬
                const hcSorted = merged
                    .filter(item => item.catCd === "HC")
                    .slice()
                    .sort((a, b) => Number(a.salecdSqno) - Number(b.salecdSqno));

                // 3) 원래 merged에서 HC였던 자리만, 정렬된 HC로 순서대로 교체
                let hcIdx = 0;
                that.productList = merged.map(item => {
                    if (item.catCd === "HC") {
                        return hcSorted[hcIdx++];
                    }
                    return item;
                });
            }

            if(data.cateList){          //카테고리 목록
                that.cateList = data.cateList;
                that.cat.cdVl1 = that.cateList[0].cdVl1
                that.cat.cdNm = that.cateList[0].cdNm

                for(var j=0 ; j<data.cateList.length ; j++){
                    var cateCnt = {catCd:data.cateList[j].cdVl1, }
                    that.cateCntList.push(cateCnt)
                }
            }
            if(data.promotionInfo){     //프로모션 정보
                that.promotionInfo = data.promotionInfo;
            }
            if(data.userId){            //내사번
                that.userId = data.userId
            }
            if(data.baseUrl){           //한눈에보기 url
                that.baseUrl = data.baseUrl
            }

            if(that.from == 'cust' && that.$route.query.myPlan != 'Y'){ // 고객에서 들어왔을때만
                var parent = that.$store.getters.parent;
                if(parent.data.eduplan){  // 고객에서 받은 고객정보.
                    if(parent.data.eduplan.targetId)
                        that.targetId = parent.data.eduplan.targetId
                    if(parent.data.eduplan.kwkkey)
                        that.edu.kwkkey = parent.data.eduplan.kwkkey
                    if(parent.data.eduplan.custNm)
                        that.edu.custNm = parent.data.eduplan.custNm
                    if(parent.data.eduplan.custDiv){
                        that.edu.custDiv = parent.data.eduplan.custDiv
                        that.getChildList() //자녀 조회 -> 계약/설계 정보조회
                    }
                }
            }else if(that.$route.query.custDiv && that.$route.query.kwkkey){    //파라미터로 고객 가져왔을때 => 푸시로 들어왔을때
                that.edu.kwkkey = that.$route.query.kwkkey
                that.edu.custNm = that.$route.query.custNm
                that.edu.custDiv = that.$route.query.custDiv

                history.replaceState({}, null, location.pathname);  //파라미터 제거

                that.getChildList() //자녀 조회 -> 계약/설계 정보조회
            }
        })
        .catch(function(error) {
            alert(error.rtMsg);
        });
    },
    showPromotionOutlink:function(){
        this.$utils.nativeIf.outbound.outlink("https://www.kyowonedu.com/KEP/EVT/KEPEvtPrchBnetDtpt.jsp?utm_source=SA&utm_medium=NAVER&utm_campaign=PC"); //빨간펜>이벤트>이달의 구매 혜택
    },
    onLongpress:function(prdt){
        // 상품 오래 누르고 있을때 동작. 외부의 상품상세페이지로 이동.
        //console.log("LONG PRESS",prdt.prdtInfoLink)
        if(prdt.prdtInfoLink){
            this.$utils.nativeIf.outbound.outlink(prdt.prdtInfoLink);
        }
    },
    chatbot: function(){
        this.$api.chatbot
        .getChatbotToken()
        .then((token) => {
          this.token = token;
          if(this.token != null){
              // this.$utils.nativeIf.outbound.outlink("https://kyowon-chatbot.ax.dalpha.so/#token="+this.token); //달파 토큰 전송
              window.location.href =  `https://kyowon-chatbot.ax.dalpha.so/#token=${encodeURIComponent(token)}&inpath=WAPLE`;
          }else {
              console.log("else token");
          }
        })
        .catch(function (error) {
          alert(error.rtMsg);
        });
    },
  },
  created: function() {
    this.getBase();
  },
  filters:{
    nvl:function(val, dftVal){
        if(!val || val == ""){
            return dftVal;
        }else{
            return val;
        }
    },
  }
};
</script>
